import { I18nComponente } from "@/types/gerais"

export const OAtributosEsperadosi18n: I18nComponente = {
  "pt-BR": {
    atributosEsperados: "atributos esperados",
  },
  "es-CO": {
    atributosEsperados: "atributos esperados",
  }
}
